// extracted by mini-css-extract-plugin
export default {"summaryCard":"billing-summary-card_summaryCard__76py6","valueContainer":"billing-summary-card_valueContainer__HSajL"};